export function formatMoney(amount, currency = "USD") {
    if (amount == null) return ""; // handle null/undefined
  
    switch (currency) {
      case "USD":
        return `$${amount.toFixed(2)}`;
      case "EUR":
        return `€${amount.toFixed(2)}`;
      case "GBP":
        return `£${amount.toFixed(2)}`;
      case "JPY":
        return `¥${amount.toFixed(2)}`;
      // Add more as needed
      default:
        return `${currency} ${amount.toFixed(2)}`; // fallback
    }
  }
  